import type { HotelTravelerOption } from '../models.js';

/** A opção do viajante pelo id — rótulo, legenda e foto vêm dela; `undefined`
 *  enquanto o catálogo do host ainda não a tem (o chamador cai no próprio id). */
export function findTraveler(
  id: string,
  travelers: readonly HotelTravelerOption[],
): HotelTravelerOption | undefined {
  return travelers.find((traveler) => traveler.id === id);
}
